<template>
  <div>
    <b-card
      v-if="isLoading"
      class="mb-2 d-flex align-items-center titulo-legenda"
    >
      <div
        class="text-center"
      >
        <b-spinner
          small
          type="grow"
          style="color: #F55559 !important;vertical-align: middle!important;"
        />
        <span class="ml-2">Carregando dados...</span>
      </div>
    </b-card>
    <div v-if="!isLoading">
      <b-card
        no-body
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <div class="d-flex align-items-center justify-content-start text-center">
                <b class="title">On-line / Off-line</b>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b class="subtitle">Liberar geração de etiquetas</b>
              <div
                v-if="config.online"
                class="m-2"
              >
                <p>Essa Ação fará com que as etiquetas impressas na Web Clientes <b>não constem ShippmentID</b></p>
                <b-row align-v="center">
                  <b-col md="3">
                    <b-button
                      variant="primary"
                      class="mb-2 mb-md-0"
                      type="button"
                      @click="confirmarOffline = true"
                    >
                      Ativar Modo Off-line
                    </b-button>
                  </b-col>
                  <b-col
                    v-if="confirmarOffline"
                    md="4"
                    align-self="stretch"
                  >
                    <p class="text-red mb-0">
                      Deseja realmente gerar etiquetas sem o ShippmentID?
                    </p>
                  </b-col>
                  <b-col
                    v-if="confirmarOffline"
                    md="5"
                  >
                    <b-button
                      variant="primary"
                      class="mr-1"
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      type="button"
                      @click="switchOnline"
                    >
                      Sim
                    </b-button>
                    <b-button
                      variant="secondary"
                      class="mr-1"
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      type="button"
                      @click="confirmarOffline = false"
                    >
                      Cancelar
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <div
                v-else
                class="m-2"
              >
                <p>Essa Ação fará com que as etiquetas impressas na Web Clientes <b>constem ShippmentID</b></p>
                <b-row align-v="center">
                  <b-col cols="3">
                    <b-button
                      variant="danger"
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      type="button"
                      @click="confirmarOnline = true"
                    >
                      Ativar Modo On-line
                    </b-button>
                  </b-col>
                  <b-col
                    v-if="confirmarOnline"
                    cols="4"
                    align-self="stretch"
                  >
                    <p class="text-red mb-0">
                      Deseja realmente gerar etiquetas com o ShippmentID?
                    </p>
                  </b-col>
                  <b-col
                    v-if="confirmarOnline"
                    cols="5"
                  >
                    <b-button
                      variant="primary"
                      class="mr-1"
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      type="button"
                      @click="switchOnline"
                    >
                      Sim
                    </b-button>
                    <b-button
                      variant="secondary"
                      class="mr-1"
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      type="button"
                      @click="confirmarOnline = false"
                    >
                      Cancelar
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card
        no-body
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <div class="d-flex align-items-center justify-content-start">
                <b class="title">Download Movimentações Automaticamente</b>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b class="subtitle">Liberar importação de movimentos automático</b>
              <b-col
                md="1"
                class="py-1"
              >
                <b-form-checkbox 
                  v-model="ativarimportacaoMovimento"
                  name="check-button"
                  size
                  switch
                />
              </b-col>
              <div
                v-if="ativarimportacaoMovimento"
                class="m-2"
              >
                <p> Os dados deste relatório são atualizados diariamente nos seguintes horários.</p>
                <p class="mb-3">
                  06h34, 08h34, 10h34, 12h34, 14h34, 15h34, 16h34, 19h34, 20h34, 23h34
                </p>
                <b-row align-v="center">
                  <b-col
                    md="2"
                  >
                    <b-form-group
                      label="Login Fraction"
                      label-for="loginFraction"
                    >
                      <b-form-input
                        id="loginFraction"
                        v-model="config.loginFraction"
                        type="text"
                        trim
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    md="2"
                  >
                    <b-form-group
                      label="Senha Fraction"
                      label-for="senhaFraction"
                    >
                      <b-form-input
                        id="senhaFraction"
                        v-model="config.senhaFraction"
                        type="password"
                        trim
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    md="2"
                  >
                    <span
                      id="tooltip-target-login-valido"
                      :class="config.loginValido == null ? '' : config.loginValido ? 'text-success' : 'text-danger'"
                    >
                      <feather-icon
                        :icon="config.loginValido == null ? 'ThumbsUpIcon' : config.loginValido ? 'ThumbsUpIcon' : 'ThumbsDownIcon'"
                        size="30"
                      />
                    </span>
                    <b-tooltip 
                      target="tooltip-target-login-valido"
                      triggers="hover"
                    >
                      <span>
                        {{ config.loginValido == null ? 'Login é checado a cada loop para importação de arquivos de movimento' : config.loginValido ? 'Login Realizado' : 'Erro ao logar, dados incorretos ou problema no fraction' }}
                      </span>
                    </b-tooltip>
                  </b-col>
                  <template v-if="config.loginValido != null"/>
                </b-row>
              </div>
              <b-col
                md="12"
              >
                <b-button
                  variant="primary"
                  class="my-1 mb-sm-0"
                  :disabled="disableSalvar()"
                  @click="salvarDados"
                >
                  Salvar Dados
                </b-button>
              </b-col>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card
        no-body
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <div class="d-flex align-items-center justify-content-start">
                <b class="title">Envio com declaração de conteúdo</b>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b class="subtitle">Permitir clientes gerar envios com declaração de conteúdo</b>
              <b-col
                md="1"
                class="py-1"
              >
                <b-form-checkbox 
                  v-model="config.permitirEnvioDeclaracaoConteudo"
                  name="check-button"
                  size
                  switch
                  @change="salvarPermitirDecConteudo()"
                />
              </b-col>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card
        no-body
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <div class="d-flex align-items-center justify-content-start">
                <b class="title">Validação do CEP para geração de etiquetas</b>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b class="subtitle">Verificar a existência do CEP na base de CEPs do DNe</b>
              <b-col
                md="6"
                class="py-1"
              >
                <b-form-checkbox 
                  v-model="config.validaCepCorreio"
                  name="check-button"
                  size
                  switch
                  @change="salvarValidaCepCorreio($event)"
                />
              </b-col>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card
        no-body
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <div class="d-flex align-items-center justify-content-start">
                <b class="title">Links de atalhos no Portal Envios do cliente</b>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b class="subtitle ml-1">URLs e ícones para os clientes acessarem como atalho ao clicar em ícones localizados na barra superior</b>
            <b-col
              md="12"
              class="pt-1"
            >
              <b-form-group
                label="URL 1"
                label-for="urlCliente1"
              >
                <b-form-input
                  id="urlCliente1"
                  v-model="config.linkCliente1"
                  type="text"
                  placeholder="https://exemplo.com"
                  :state="url1State"
                  trim
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <div 
                id="app"
                class="container mt-0"
              >
                <div class="card shadow">
                  <span class="mb-0">
                    Ícone 1
                  </span>
                  <div class="text-left">
                    <div class="d-flex flex-wrap justify-content-start icon-radio-group">
                      <label
                        v-for="option in options" 
                        :key="option.id" 
                        class="btn btn-outline-primary"
                        :class="{ active: config.iconeCliente1 === option.value }"
                      >
                        <input
                          v-model="config.iconeCliente1"  
                          type="radio"
                          name="icon-choice"
                          :value="option.value"
                        >
                        <i :class="option.icon"/>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              md="3"
            >
              <b-form-group
                label="Tooltip (nome) do ícone"
                label-for="tooltip1"
              >
                <b-form-input
                  id="tooltip1"
                  v-model="config.tooltipIcone1"
                  type="text"
                  placeholder="Link 1"
                  trim
                />
              </b-form-group>
            </b-col>
            <b-col
              md="12"
            >
              <b-form-group
                label="URL 2"
                label-for="urlCliente2"
              >
                <b-form-input
                  id="urlCliente2"
                  v-model="config.linkCliente2"
                  type="text"
                  placeholder="https://exemplo.com"
                  :state="url2State"
                  trim
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <div 
                id="app"
                class="container mt-0"
              >
                <div class="card shadow">
                  <span class="mb-0">
                    Ícone 2
                  </span>
                  <div class="text-left">
                    <div class="d-flex flex-wrap justify-content-start icon-radio-group">
                      <label
                        v-for="option in options" 
                        :key="option.id" 
                        class="btn btn-outline-primary"
                        :class="{ active: config.iconeCliente2 === option.value }"
                      >
                        <input
                          v-model="config.iconeCliente2"  
                          type="radio"
                          name="icon-choice"
                          :value="option.value"
                        >
                        <i :class="option.icon"/>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              md="3"
            >
              <b-form-group
                label="Tooltip (nome) do ícone"
                label-for="tooltip2"
              >
                <b-form-input
                  id="tooltip2"
                  v-model="config.tooltipIcone2"
                  type="text"
                  placeholder="Link 2"
                  trim
                />
              </b-form-group>
            </b-col>
            <b-col
              md="12"
            >
              <b-button
                variant="primary"
                class="mr-sm-1 mr-0 my-1 mb-sm-0"
                @click="salvarDadosUrlCliente"
              >
                Salvar Dados
              </b-button>
              <b-button
                variant="outline-secondary"
                class="mr-sm-1 mr-0 my-1 mb-sm-0"
                @click="cancelarAlterarDadosUrlCliente"
              >
                Cancelar Alterações
                <feather-icon
                  icon="RefreshCwIcon"
                  class="ml-1"
                />
              </b-button>
              <b-button
                :disabled="!temURL1"
                variant="danger"
                class="mr-sm-1 mr-0 my-1 mb-sm-0"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                @click="excluirDadosUrlCliente"
              >
                Excluir Dados
                <feather-icon
                  icon="TrashIcon"
                  class="ml-1"
                />
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import swal from 'sweetalert2/dist/sweetalert2.min'
import store from '@/store'
import { ref, computed, onBeforeMount, reactive, toRefs } from '@vue/composition-api'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { $themeConfig } from '@themeConfig'

export default {
  name: 'ConfiguracoesGerais',
  setup() {
    const { appCarregando } = $themeConfig.app
    const empresaStore = createNamespacedHelpers('empresa')
    const confirmarOffline = ref(false)
    const confirmarOnline = ref(false)
    const ativarimportacaoMovimento = ref(false)
    const isLoading = ref(true)
    const temSenhaFraction = ref(false)
    const temURL1 = ref(false)
    const url1State = ref(null)
    const url2State = ref(null)

    const state = reactive({
      config: empresaStore.useGetters(['configUnidade']).configUnidade,
      oldData: null,
    })

    const empresaId = computed(() => {
      const user = JSON.parse(window.localStorage.getItem('userName'))
      return user ? user.empresaId : null
    })

    onBeforeMount(() => {
      if (empresaId.value) {
        store.dispatch('empresa/configuracoesUnidade', empresaId.value).then(() => {
          ativarimportacaoMovimento.value = state.config.loginFraction != null
          temSenhaFraction.value = state.config.senhaFraction != null
          temURL1.value = state.config.linkCliente1 != null
          state.oldData = { ...state.config }
          isLoading.value = false
        })
      }
    })

    const salvarPermitirDecConteudo = () => {
      const msg = state.config.permitirEnvioDeclaracaoConteudo ? 'Ativa' : 'Desativa'
      swal.fire({
        title: 'Atenção!',
        icon: 'warning',
        html: `Você tem certeza que deseja ${msg}r a geração de etiquetas com declaração de conteúdo dos clientes?`,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          isLoading.value = true
          appCarregando.show()
          store.dispatch('empresa/salvarEnvioDecConteudo', empresaId.value).then(() => {
            store.dispatch('empresa/configuracoesUnidade', empresaId.value).then(() => {
              isLoading.value = false
              appCarregando.hide()
              swal.fire({
                icon: 'success',
                html: `Etiquetas com declaração ${msg}das com sucesso`,
                width: 400,
                showConfirmButton: true,
              })
            }).catch(() => {
              appCarregando.hide()
              swal.fire({
                icon: 'error',
                text: 'Erro ao alterado modo!',
                width: 400,
                showConfirmButton: true,
              })
            })
          })
        } else {
          state.config.permitirEnvioDeclaracaoConteudo = !state.config.permitirEnvioDeclaracaoConteudo
        }
      })
    }

    const salvarValidaCepCorreio = value => {
      const msg = value ? 'Deseja verificar a existência do CEP na base de CEPs do DNe?' : 'Deseja parar de verificar a existência do CEP na base de CEPs do DNe?'
      swal.fire({
        title: 'Atenção!',
        icon: 'warning',
        html: msg,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          isLoading.value = true
          appCarregando.show()
          store.dispatch('empresa/salvarValidaCepCorreio', empresaId.value).then(() => {
            store.dispatch('empresa/configuracoesUnidade', empresaId.value).then(() => {
              isLoading.value = false
              appCarregando.hide()
              swal.fire({
                icon: 'success',
                html: 'Modo de validação do CEP alterado com sucesso!',
                width: 400,
                showConfirmButton: true,
              })
            }).catch(() => {
              appCarregando.hide()
              swal.fire({
                icon: 'error',
                text: 'Ocorreu um erro',
                width: 400,
                showConfirmButton: true,
              })
            })
          })
        } else {
          state.config.validaCepCorreio = !value
        }
      })
    }

    const switchOnline = () => {
      confirmarOffline.value = false
      confirmarOnline.value = false
      appCarregando.show()
      store.dispatch('empresa/switchOnline', empresaId.value).then(() => {
        store.dispatch('empresa/configuracoesUnidade', empresaId.value).then(() => {
          appCarregando.hide()
          swal.fire({
            icon: 'success',
            text: 'Modo alterado com sucesso!',
            width: 400,
            showConfirmButton: true,
          })
        }).catch(() => {
          appCarregando.hide()
          swal.fire({
            icon: 'error',
            text: 'Erro ao alterar modo!',
            width: 400,
            showConfirmButton: true,
          })
        })
      })
    }

    const salvarDados = () => {
      let value
      if (!ativarimportacaoMovimento.value) {
        state.config.loginFraction = null
        state.config.senhaFraction = null
        state.config.loginValido = null
        value = true
      } else {
        value = (state.config.senhaFraction !== state.oldData.senhaFraction)
        || (state.config.loginFraction !== state.oldData.loginFraction)
      }

      if (value) {
        appCarregando.show()
        store.dispatch('empresa/salvarConfiguracoesUnidade', empresaId.value).then(() => {
          appCarregando.hide()
          temSenhaFraction.value = true
          swal.fire({
            icon: 'success',
            text: 'Login salvo com sucesso!',
            width: 400,
            showConfirmButton: true,
          })
          state.oldData = { ...state.config }
        }).catch(() => {
          appCarregando.hide()
          swal.fire({
            icon: 'error',
            html: 'Erro ao salvar Login!',
            width: 400,
            showConfirmButton: true,
          })
        })
      }
    }

    const disableSalvar = () => {
      if (!ativarimportacaoMovimento.value) {
        return false
      }
      if (state.config.loginFraction != null
      && state.config.loginFraction !== ''
      && state.config.senhaFraction != null
      && state.config.senhaFraction !== '') {
        if (state.config.loginFraction !== state.oldData.loginFraction || state.config.senhaFraction !== state.oldData.senhaFraction) {
          return false
        }
      }
      return true
    }

    const salvarDadosUrlCliente = () => {
      let cleanUrl1 = state.config.linkCliente1
      if (cleanUrl1 === null || cleanUrl1 === '') {
        url1State.value = false
        swal.fire({
          icon: 'error',
          html: 'Informe a URL 1!',
          width: 400,
          showConfirmButton: true,
        })
        return
      }
      if (!/^https?:\/\//i.test(cleanUrl1)) {
        cleanUrl1 = `https://${cleanUrl1}`
      }
      const pattern = /^(https?:\/\/)[\w.-]+(\.[\w.-]+)+[/#?]?.*$/
      const isUrlValid1 = pattern.test(cleanUrl1)
      if (!isUrlValid1) {
        url1State.value = false
        swal.fire({
          icon: 'error',
          html: 'URL 1 inválida!',
          width: 400,
          showConfirmButton: true,
        })
        return
      }
      url1State.value = true
      state.config.linkCliente1 = cleanUrl1
      let cleanUrl2 = state.config.linkCliente2
      if (!/^https?:\/\//i.test(cleanUrl2)) {
        cleanUrl2 = `https://${cleanUrl2}`
      }
      const isUrlValid2 = pattern.test(cleanUrl2)
      if (!isUrlValid2 && (state.config.linkCliente2 !== null && state.config.linkCliente2 !== '')) {
        url2State.value = false
        swal.fire({
          icon: 'error',
          html: 'URL 2 inválida!',
          width: 400,
          showConfirmButton: true,
        })
        return
      }
      if (state.config.linkCliente2 !== null && state.config.linkCliente2 !== '') {
        url2State.value = true
        state.config.linkCliente2 = cleanUrl2
      } else {
        url2State.value = null
        state.config.linkCliente2 = null
      }
      const dados = {
        link1: state.config.linkCliente1,
        link2: state.config.linkCliente2,
        icone1: state.config.iconeCliente1,
        icone2: state.config.iconeCliente2,
        tooltip1: state.config.tooltipIcone1,
        tooltip2: state.config.tooltipIcone2,
      }
      appCarregando.show()
      store.dispatch('empresa/salvarLinksClientes', dados).then(() => {
        appCarregando.hide()
        temURL1.value = true
        swal.fire({
          icon: 'success',
          text: 'URLs salvas com sucesso!',
          width: 400,
          showConfirmButton: true,
        })
      }).catch(() => {
        appCarregando.hide()
        swal.fire({
          icon: 'error',
          html: 'Erro ao salvar URLs!',
          width: 400,
          showConfirmButton: true,
        })
      })
    }

    const cancelarAlterarDadosUrlCliente = () => {
      url1State.value = null
      url2State.value = null
      state.config.linkCliente1 = state.oldData.linkCliente1
      state.config.iconeCliente1 = state.oldData.iconeCliente1
      state.config.linkCliente2 = state.oldData.linkCliente2
      state.config.iconeCliente2 = state.oldData.iconeCliente2
    }

    const excluirDadosUrlCliente = () => {
      swal.fire({
        title: 'Atenção!',
        icon: 'warning',
        html: 'Confirma exclusão das URLs?',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const dados = {
            link1: null,
            link2: null,
            icone1: null,
            icone2: null,
            tooltip1: null,
            tooltip2: null,
          }
          appCarregando.show()
          store.dispatch('empresa/salvarLinksClientes', dados).then(() => {
            appCarregando.hide()
            swal.fire({
              icon: 'success',
              text: 'URLs excluídas com sucesso!',
              width: 400,
              showConfirmButton: true,
            })
          }).catch(() => {
            appCarregando.hide()
            swal.fire({
              icon: 'error',
              html: 'Erro ao salvar URLs!',
              width: 400,
              showConfirmButton: true,
            })
          })
        }
      })
    }

    const options = [
      { id: 1, value: 'external-link-alt', icon: 'fas fa-external-link-alt' },
      { id: 2, value: 'minus-circle', icon: 'fas fa-minus-circle' },
      { id: 3, value: 'comment-dots', icon: 'fas fa-comment-dots' },
      { id: 5, value: 'headset', icon: 'fas fa-headset' },
      { id: 6, value: 'life-ring', icon: 'fas fa-life-ring' },
      { id: 7, value: 'info-circle', icon: 'fas fa-info-circle' },
      { id: 8, value: 'sliders-h', icon: 'fas fa-sliders-h' },
    ]

    const getIconClass = value => {
      const option = options.find(o => o.valueOf === value)
      return option ? option.icon : ''
    }

    return {
      ...toRefs(state),
      confirmarOffline,
      confirmarOnline,
      ativarimportacaoMovimento,
      salvarPermitirDecConteudo,
      salvarValidaCepCorreio,
      isLoading,
      empresaId,
      switchOnline,
      temSenhaFraction,
      temURL1,
      salvarDados,
      disableSalvar,
      salvarDadosUrlCliente,
      cancelarAlterarDadosUrlCliente,
      excluirDadosUrlCliente,
      url1State,
      url2State,
      getIconClass,
      options,
    }
  },
}
</script>

<style>
.radio-button .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #61AA82 !important;
  border-width: 7px!important;
  background-color: #FFF !important;
}

.radio-button .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #61AA82 !important;
  border-width: 2px!important;
  background-color: #FFF !important;
}

.radio-button .custom-control-input:not(:checked):hover ~ .custom-control-label::before {
  border-color: #61AA82 !important;
  border-width: 2px!important;
  background-color: #FFF !important;
}

</style>

<style lang="scss" scoped>
.title {
    font-size: 1.7rem;
    margin-bottom: 1rem;
}
.subtitle {
    font-size: 1.3rem;
}

.text-red {
    color: red;
}

.btn-danger.disabled, [dir] .btn-danger:disabled {
  background-color: #818181!important;
  border-color: #818181!important;
}

.icon-radio-group .btn-outline-primary {
  width: 45px;
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5px;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.icon-radio-group .btn-outline-primary i {
  font-size: 1.5rem;
  margin-bottom: 5px;
}
.icon-radio-group input[type="radio"] {
  display: none;
}
.btn-outline-primary:hover:not(.disabled):not(:disabled) {
  background-color: rgba(97, 170, 130, 0.14)!important;
}
.btn-outline-primary:not(:disabled):not(.disabled).active {
  color: #ffffff!important;
}
.btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):focus {
  background-color: #F55559 !important;
}
.icon-radio-group .btn-outline-primary i {
  margin-bottom: 0!important;
}
</style>